import React from "react";

const modalContext = React.createContext({
  isOpen: false,
  modalCode: "",
  modalTitle: "",
  modalParams: {},
  onClose: () => {},
  handleOpenModal: (code, title, params = undefined) => {},
});
export default modalContext;
